"use strict";

/* ------------------------------------------------------------------ *
 * Mapper 240: Jing Ke Xin Zhuan / Sheng Huo Lie Zhuan
 * ------------------------------------------------------------------ *
 * Register at $4020-$5FFF: upper nibble selects 32 KB PRG bank,
 * lower nibble selects 8 KB CHR bank.
 * See https://www.nesdev.org/wiki/INES_Mapper_240
 */

function register(Mappers) {
  Mappers[240] = function (nes) {
    this.nes = nes;
    // Upper nibble: 32 KB PRG bank select (2 bits, 4 banks of 32 KB)
    this.prgBank = 0;
    // Lower nibble: 8 KB CHR bank select (4 bits, 16 banks of 8 KB)
    this.chrBank = 0;
    // Mirroring mode: 0 = vertical, 1 = horizontal
    this.mirroring = 0;
  };

  Mappers[240].prototype = new Mappers[0]();

  Mappers[240].prototype.write = function (address, value) {
    if (address < 0x4020 || address > 0x5fff) {
      Mappers[0].prototype.write.apply(this, arguments);
      return;
    }

    // Upper nibble: 32 KB PRG bank select
    this.prgBank = (value >> 4) & 0x03;
    this.load32kRomBank(this.prgBank, 0x8000);

    // Lower nibble: 8 KB CHR bank select
    this.chrBank = value & 0x0f;
    this.load8kVromBank(this.chrBank * 2, 0x0000);
  };

  Mappers[240].prototype.loadROM = function () {
    if (!this.nes.rom.valid) {
      throw new Error("Mapper 240: Invalid ROM! Unable to load.");
    }

    // Load PRG-ROM: first bank at $8000, last bank fixed at $C000
    this.load32kRomBank(0, 0x8000);
    this.load32kRomBank(this.nes.rom.romCount - 1, 0xc000);

    // Load CHR data
    this.loadCHRROM();

    // Reset interrupt handler
    this.resetIrqHandler();
  };
}

module.exports = { register: register };
